export default __webpack_public_path__ + "static/media/SolarPanelsImage.aab56773.svg";